export const TRN_CREATOR_VALUES = 'TRN_CREATOR_VALUES'
export const TRN_CREATOR_VALUES_REMOVE = 'TRN_CREATOR_VALUES_REMOVE'
export const TRN_CREATOR_VALUES_CLEANUP = 'TRN_CREATOR_VALUES_CLEANUP'

export const creatorValues = (payload) => ({
  payload,
  type: TRN_CREATOR_VALUES,
})

export const creatorValuesRemove = (...payload) => ({
  payload,
  type: TRN_CREATOR_VALUES_REMOVE,
})

export const creatorValuesCleanUp = () => ({
  payload: null,
  type: TRN_CREATOR_VALUES_CLEANUP,
})
